import { UserAvatar } from '@shared'
import { useUserState } from '@store'

import shield from '../../assets/progress/shield.svg'
import styles from './Avatar.module.scss'

export const Avatar = () => {
  const profile = useUserState()
  return (
    <div className={styles.container}>
      {profile?.username && (
        <h1 className={styles.username}>@{profile.username}</h1>
      )}
      <UserAvatar size={125} className={styles.containerAvatar} lineGradient />
      <div className={styles.emblem}>
        <img src={shield} alt="emblem" />
      </div>
    </div>
  )
}
